import React, { useState } from "react";
import { Link } from "react-router-dom";
// import Slider from "react-slick";
import { useModal } from "../../contexts/ModalContext";
import BookingPopup from "../../components/BookingPopup";

export default function HomeServices({ data }) {
  const { openQueryModal } = useModal();
  // const [showDimensionModel, setShowDimensionModel] = useState(false);
  // const [selectedService, setSelectedService] = useState(null);
  const [showSerachEngine, setshowSerachEngine] = useState(false);
  const { title, description, services } = data;

  // const settingskey = {
  //   autoplay: false,
  //   autoplaySpeed: 4000,
  //   speed: 4000,
  //   infinite: true,
  //   arrows: true,
  //   dots: false,
  //   pauseOnHover: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   prevArrow: (
  //     <button className="slick-arrow slick-prev" aria-label="Previous Slide">
  //       <i className="fa-solid fa-arrow-left"></i>
  //     </button>
  //   ),
  //   nextArrow: (
  //     <button className="slick-arrow slick-next" aria-label="Next Slide">
  //       <i className="fa-solid fa-arrow-right"></i>
  //     </button>
  //   ),
  //   responsive: [


  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 2,
  //       },
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 1,
  //       },
  //     },

  //     {
  //       breakpoint: 99999,
  //       settings: "unslick",
  //     },
  //   ],
  // };


  return (
    <>
      <section className="home-services">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-8">
              <div className="services-text">
                <h2 className="heading">{title}</h2>
                <p>{description}</p>
              </div>
            </div>
          </div>
          <div className="services-row">
            {services.map((item, index) => (
              <div className="services-col" key={index}>
                <div className="services-inner">
                  <div className="services-inner-wraps">
                    <div className="sevice-img">
                      <img src={item.image} alt={item.title} className="img-responsive" loading="lazy" />
                    </div>

                    <div className="content-wrapper">
                      {/* <button className="ton-button">{item.ton}</button> */}
                      <div className="heading" dangerouslySetInnerHTML={{ __html: item.title }}></div>
                      <div className="dimension-wrap">
                        <p>{item.size}</p>
                        {/* <p className="dollar-text">{item.bags}</p> */}
                        <p className="dollar-text">
                          {item.bags === "Concrete Bin only" ? (
                            <strong>{item.bags}</strong>
                          ) : (
                            item.bags
                          )}
                        </p>
                      </div>

                      {/* <Link className="show-more-text" onClick={() => { setSelectedService(item); setShowDimensionModel(true); }}> Show More</Link> */}
                      <div className="services-btn">   <Link className="theme-btn"
                        onClick={() => { if (item.isBusiness) { openQueryModal(); } else { setshowSerachEngine(true); } }}   >
                        <span className="color-overlay"></span>
                        <span className="btn-txt">{item.btn}</span>
                      </Link>
                        <Link className="theme-btn default-btn2" to={item.bnt2link}>
                          <span className="color-overlay"></span>
                          <span className="btn-txt">{item.btn2} </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* <div className="row">
          <div className="col-md-12">
            <div className="bottom-btn">
              <Link className="theme-btn" to="">
                <span className="color-overlay"></span>
                <span className="btn-txt">Need other Size ?</span>
              </Link>
            </div>
          </div>
        </div> */}
        </div>
      </section>
      <BookingPopup isOpen={showSerachEngine} onClose={() => setshowSerachEngine(false)} />
    </>

  );
}
